export const LONG_DATE_FORMAT = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'long',
});

/**
 * This formatter uses the `en-US` locale and ensures the output is
 * formatted in MM/DD/YYYY format (e.g., 11/22/2024). Dates are treated as UTC.
 */
export const dateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'UTC',
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
});

/**
 * This formatter uses the `en-US` locale and ensures the output is
 * formatted in MMMM d, yyyy 'at' hh:mm a format (e.g., November 1, 2024 at 12:00 AM).
 *
 * @param {Date} date - The date to be formatted.
 * @returns {string} The formatted date string.
 */
export const formatDateWithTime = (date: Date) => {
  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'long',
    timeStyle: 'short',
  }).format(date);
};

/**
 * Formats a date in the viewer's time zone with the zone's short name (e.g., Thursday, November 12, 2026 at 10:00 AM
 * EST). Uses separate fields because Intl rejects timeZoneName alongside dateStyle or timeStyle.
 *
 * @param {Date | string} date - The date, or an ISO string as a JSON reply carries it.
 * @param {string} [timeZone] - An IANA zone such as 'America/New_York'. Defaults to the viewer's.
 */
export const formatDateWithTimeZone = (date: Date | string, timeZone?: string) => {
  return new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  }).format(new Date(date));
};
